import type { TemplateOnlyComponent } from '@ember/component/template-only';
import PageTitle from 'ember-page-title/helpers/page-title';
import Version from 'login/models/version';

type WLoginDialogSignature = {
  Element: HTMLDivElement;
  Args: {
    pageTitle: string;
    dialogTitle: string;
    version: Version;
  };
  Blocks: {
    default: [];
  };
};

export default <template>
  {{PageTitle @pageTitle}}

  <div class='dialog' ...attributes>
    <div class='header grey'>
      {{@dialogTitle}}

      <div class='version'>
        {{@version.shortVersion}}
      </div>
    </div>

    {{yield}}

  </div>
</template> satisfies TemplateOnlyComponent<WLoginDialogSignature>;
